import { marked } from 'marked';

/**
 * Match FormatMessagePipe: markdown → HTML string (sync).
 */
export function markdownToFormattedHtml(value: string): string {
  if (!value) {
    return '';
  }
  let formattedValue = marked.parse(value, { async: false }) as string;
  formattedValue = formattedValue.replace(
    /<h\d>(.*?)<\/h\d>/g,
    (_match: string, p1: string): string => {
      return `<h3><strong>${p1}</strong></h3>`;
    }
  );
  return formattedValue;
}

/**
 * Mirrors PdfDownloadService.convertToPlainText structure using DOMParser (worker-safe).
 */
export function htmlToPlainText(formattedHtml: string): string {
  if (!formattedHtml) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${formattedHtml}</div>`, 'text/html');
  const tempDiv = doc.body.firstChild as { childNodes: any[]; nodeType: number; textContent: string | null } | null;
  if (!tempDiv) {
    return '';
  }

  const TEXT_NODE = 3;
  const ELEMENT_NODE = 1;

  const processNode = (node: any): string => {
    if (node.nodeType === TEXT_NODE) {
      const tc = node.textContent || '';
      return tc.length === 1 ? tc.trim() : tc;
    }
    if (node.nodeType === ELEMENT_NODE) {
      const tag = (node.tagName || '').toLowerCase();
      switch (tag) {
        case 'h3':
        case 'p':
          return `\n\n${Array.from(node.childNodes).map(processNode).join('')}`;
        case 'ul':
        case 'br':
          return `\n${Array.from(node.childNodes).map(processNode).join('')}`;
        case 'li':
          return `\n• ${Array.from(node.childNodes).map(processNode).join('')}`;
        default:
          return Array.from(node.childNodes).map(processNode).join('');
      }
    }
    return '';
  };

  return processNode(tempDiv).trim();
}

export function markdownToPlainText(value: string): string {
  return htmlToPlainText(markdownToFormattedHtml(value));
}

export function normalizeSearchField(value: string, isMarkdown: boolean): string {
  if (!value) {
    return '';
  }
  return isMarkdown ? markdownToPlainText(value) : value;
}
